import { Spinner as BSSpinner } from 'react-bootstrap';

export default function Spinner() {
  return (
    <div className="mx-auto p-3" style={{ width: 0 }}>
      <BSSpinner animation="border" variant="primary" />
    </div>
  );
}
